export default {"src":"/_next/static/media/check-feature.e214c559.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};